module.exports = __webpack_public_path__ + "static/media/cvs-dot.c9ef2f7d.png";